// PROD-1184 / PROD-1187 (Alex 2026-10-19, Doctors tab map). The two rules of "My location", pure, so
// the gate check-map-my-location runs them.
//
// "Known" means the patient's own point: the device, or an address they searched for (`precise`).
// A ZIP-only location (`home`, permission denied or never asked) is not known: distances (PROD-1187)
// then stay as before, but "My location" (PROD-1184) is shown the same way and recentres on the ZIP.

/** The patient's point when it is known, else null. */
export function patientPoint(userLocation) {
  if (!userLocation || !userLocation.precise) return null
  const { lat, lng } = userLocation
  return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null
}

/** PROD-1184: is the "My location" control shown? Whenever the map is away from the patient's point
 *  (the device, a searched address or the home ZIP): they moved it, or an area is searched. */
export function myLocationShown({ area, areaView }) {
  return !!(area || areaView)
}

/** PROD-1187: where every distance label is measured from. The patient's point when known, also
 *  after "Search this area"; otherwise the searched area's centre, or the location bar's point. */
export function milesOrigin(userLocation, area) {
  return patientPoint(userLocation) || (area ? { lat: area.lat, lng: area.lng } : userLocation)
}
